<template>
  <svg
    v-if="icon == 'linkedin'"
    :class="attrs.class"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 30 30"
    width="30px"
    fill="currentColor"
    height="30px"
  >
    <path
      d="M9,25H4V10h5V25z M6.501,8C5.118,8,4,6.879,4,5.499S5.12,3,6.501,3C7.879,3,9,4.121,9,5.499C9,6.879,7.879,8,6.501,8z M27,25h-4.807v-7.3c0-1.741-0.033-3.98-2.499-3.98c-2.503,0-2.888,1.896-2.888,3.854V25H12V9.989h4.614v2.051h0.065 c0.642-1.18,2.211-2.424,4.551-2.424c4.87,0,5.77,3.109,5.77,7.151C27,16.767,27,25,27,25z"
    />
  </svg>
  <svg
    v-if="icon == 'crunchbase'"
    :class="attrs.class"
    width="800px"
    height="800px"
    viewBox="0 0 24 24"
    role="img"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.6 0H2.4A2.41 2.41 0 0 0 0 2.4v19.2A2.41 2.41 0 0 0 2.4 24h19.2a2.41 2.41 0 0 0 2.4-2.4V2.4A2.41 2.41 0 0 0 21.6 0zM7.045 14.465A2.11 2.11 0 0 0 9.84 13.42h1.66a3.69 3.69 0 1 1 0-1.75H9.84a2.11 2.11 0 1 0-2.795 2.795zm11.345.845a3.55 3.55 0 0 1-1.06.63 3.68 3.68 0 0 1-3.39-.38v.38h-1.51V5.37h1.5v4.11a3.74 3.74 0 0 1 1.8-.63H16a3.67 3.67 0 0 1 2.39 6.46zm-.223-2.766a2.104 2.104 0 1 1-4.207 0 2.104 2.104 0 0 1 4.207 0z"
    />
  </svg>
  <svg
    v-if="icon == 'twitter'"
    :class="attrs.class"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z"
    />
  </svg>
  <img v-if="icon == 'pitchbook'" :class="attrs.class" src="/images/pitchbook.png" />
  <svg
    v-if="icon == 'discord'"
    :class="attrs.class"
    viewBox="0 0 16 13"
    class="h-4 w-4"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.969 1.01131C11.9926 0.54322 10.9455 0.19835 9.85069 0.000828577C9.83076 -0.00298353 9.81084 0.00654313 9.80057 0.0255969C9.66591 0.275832 9.51674 0.602284 9.41228 0.858874C8.23476 0.674694 7.06328 0.674694 5.90989 0.858874C5.80542 0.596581 5.65084 0.275832 5.51557 0.0255969C5.5053 0.00717885 5.48538 -0.0023478 5.46544 0.000828577C4.37125 0.197719 3.32416 0.542589 2.34711 1.01131C2.33865 1.01512 2.3314 1.02148 2.32659 1.02973C0.340482 4.12978 -0.203597 7.15363 0.06331 10.14C0.0645177 10.1546 0.0723678 10.1686 0.0832374 10.1775C1.39361 11.1828 2.66294 11.7932 3.90869 12.1978C3.92863 12.2041 3.94975 12.1965 3.96244 12.1794C4.25713 11.7589 4.51981 11.3156 4.74504 10.8494C4.75833 10.8221 4.74564 10.7897 4.71847 10.7789C4.30181 10.6138 3.90507 10.4124 3.52343 10.1838C3.49324 10.1654 3.49082 10.1203 3.51859 10.0987C3.59891 10.0358 3.67924 9.97039 3.75592 9.90434C3.7698 9.89228 3.78913 9.88973 3.80544 9.89735C6.31266 11.0933 9.02702 11.0933 11.5047 9.89735C11.521 9.8891 11.5403 9.89164 11.5548 9.90371C11.6315 9.96976 11.7118 10.0358 11.7927 10.0987C11.8205 10.1203 11.8187 10.1654 11.7885 10.1838C11.4068 10.4169 11.0101 10.6138 10.5928 10.7783C10.5657 10.7891 10.5536 10.8221 10.5669 10.8494C10.7969 11.315 11.0596 11.7583 11.3489 12.1787C11.3609 12.1965 11.3827 12.2041 11.4026 12.1978C12.6544 11.7932 13.9237 11.1828 15.2341 10.1775C15.2456 10.1686 15.2528 10.1552 15.254 10.1406C15.5735 6.68806 14.719 3.68901 12.9889 1.03036C12.9847 1.02148 12.9775 1.01512 12.969 1.01131ZM5.11945 8.3216C4.3646 8.3216 3.74263 7.59757 3.74263 6.70839C3.74263 5.81921 4.35254 5.09518 5.11945 5.09518C5.89237 5.09518 6.50832 5.82557 6.49624 6.70839C6.49624 7.59757 5.88633 8.3216 5.11945 8.3216ZM10.21 8.3216C9.45516 8.3216 8.83319 7.59757 8.83319 6.70839C8.83319 5.81921 9.44307 5.09518 10.21 5.09518C10.9829 5.09518 11.5989 5.82557 11.5868 6.70839C11.5868 7.59757 10.9829 8.3216 10.21 8.3216Z"
    ></path>
  </svg>
  <svg
    v-if="icon == 'unarchieve'"
    :class="attrs.class"
    viewBox="0 0 12 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.9999 0.599609C1.57556 0.599609 1.16859 0.76818 0.868531 1.06824C0.568473 1.3683 0.399902 1.77526 0.399902 2.19961V13.3996L3.1999 11.7996L5.9999 13.3996L8.7999 11.7996L11.5999 13.3996V2.19961C11.5999 1.77526 11.4313 1.3683 11.1313 1.06824C10.8312 0.76818 10.4242 0.599609 9.9999 0.599609H1.9999ZM5.7655 3.56521C5.91123 3.41433 5.99186 3.21225 5.99004 3.00249C5.98822 2.79273 5.90408 2.59208 5.75576 2.44375C5.60743 2.29543 5.40678 2.21129 5.19702 2.20947C4.98727 2.20765 4.78518 2.28828 4.6343 2.43401L2.2343 4.83401C2.08433 4.98403 2.00007 5.18748 2.00007 5.39961C2.00007 5.61174 2.08433 5.81519 2.2343 5.96521L4.6343 8.36521C4.78518 8.51094 4.98727 8.59157 5.19702 8.58975C5.40678 8.58793 5.60743 8.50379 5.75576 8.35546C5.90408 8.20714 5.98822 8.00649 5.99004 7.79673C5.99186 7.58697 5.91123 7.38489 5.7655 7.23401L4.7311 6.19961H5.9999C6.63642 6.19961 7.24687 6.45247 7.69696 6.90255C8.14705 7.35264 8.3999 7.96309 8.3999 8.59961V9.39961C8.3999 9.61178 8.48419 9.81527 8.63422 9.96529C8.78425 10.1153 8.98773 10.1996 9.1999 10.1996C9.41208 10.1996 9.61556 10.1153 9.76559 9.96529C9.91562 9.81527 9.9999 9.61178 9.9999 9.39961V8.59961C9.9999 7.53874 9.57847 6.52133 8.82833 5.77118C8.07818 5.02104 7.06077 4.59961 5.9999 4.59961H4.7311L5.7655 3.56521Z"
      fill="currentColor"
    />
  </svg>
  <svg v-if="icon == 'unpin'" :class="attrs.class" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.35954 0.295797L8.40897 2.03788L2.36903 7.1486L3.30218 5.15004C3.31455 5.12355 3.32096 5.09466 3.32096 5.06543V2.26077C3.32096 2.22057 3.30884 2.18129 3.28619 2.14808L2.03431 0.312697C1.94375 0.179938 2.03883 0 2.19953 0H9.18398C9.3358 0 9.43226 0.162521 9.35954 0.295797ZM8.32102 4.36745L12.256 1.08831C12.4681 0.911532 12.4968 0.596249 12.32 0.384111C12.1432 0.171972 11.8279 0.14331 11.6158 0.320092L0.384022 9.67991C0.171884 9.85669 0.143221 10.172 0.320003 10.3841C0.496785 10.5962 0.812068 10.6249 1.02421 10.4481L3.97482 7.98928H4.64779C4.7472 7.98928 4.83151 8.06229 4.84573 8.16067L5.26486 11.0602C5.29783 11.2882 5.48237 11.4642 5.71173 11.4863L5.823 11.497C6.098 11.5236 6.34238 11.322 6.36872 11.047L6.64421 8.17022C6.65404 8.06761 6.74023 7.98928 6.8433 7.98928H9.22093C9.36365 7.98928 9.46044 7.84409 9.40554 7.71235L8.33641 5.14674C8.32625 5.12237 8.32102 5.09622 8.32102 5.06981V4.36745Z"
      fill="currentColor"
    />
  </svg>
  <svg v-if="icon == 'pin'" :class="attrs.class" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.48121 5.36586C1.49358 5.33937 1.49999 5.31048 1.49999 5.28125V2.4766C1.49999 2.43639 1.48787 2.39711 1.46522 2.3639L0.213339 0.528517C0.122787 0.395758 0.217864 0.21582 0.378565 0.21582H7.36301C7.51483 0.21582 7.6113 0.378342 7.53857 0.511617L6.52449 2.3701C6.50846 2.39948 6.50005 2.43242 6.50005 2.4659V5.28563C6.50005 5.31204 6.50528 5.33819 6.51544 5.36256L7.58457 7.92817C7.63947 8.05991 7.54268 8.2051 7.39996 8.2051H5.02234C4.91926 8.2051 4.83307 8.28343 4.82325 8.38604L4.54775 11.2628C4.52141 11.5379 4.27703 11.7394 4.00203 11.7129L3.89076 11.7021C3.6614 11.68 3.47686 11.504 3.4439 11.276L3.02477 8.37649C3.01055 8.27811 2.92623 8.2051 2.82683 8.2051H0.469644C0.323303 8.2051 0.226512 8.05309 0.288425 7.92049L1.48121 5.36586Z"
      fill="currentColor"
    />
  </svg>
  <svg v-if="icon == 'unread'" :class="attrs.class" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.5882 2.66668C11.3679 2.66668 12 2.06972 12 1.33334C12 0.596957 11.3679 0 10.5882 0C9.80854 0 9.17647 0.596957 9.17647 1.33334C9.17647 2.06972 9.80854 2.66668 10.5882 2.66668ZM6.70588 1.27511L8.47146 1.27504C8.47088 1.2943 8.47059 1.31362 8.47059 1.33301C8.47059 2.43759 9.41869 3.33302 10.5882 3.33302C10.8357 3.33302 11.0733 3.29292 11.2941 3.21922V7.66666C11.2941 8.40304 10.662 9 9.88235 9H1.41176C0.632069 9 0 8.40304 0 7.66666V2.40563C0 1.94591 0.250757 1.51861 0.663531 1.27496L4.58824 1.27494C4.58824 1.23925 6.70588 1.27511 6.70588 1.27511ZM3.67353 3.83222C3.34916 3.62799 2.9109 3.71077 2.69465 4.01712C2.4784 4.32348 2.56605 4.73739 2.89042 4.94163L5.29412 6.60831C5.53122 6.75759 5.84012 6.75759 6.07722 6.60831L8.47059 4.94163C8.79496 4.73739 8.88261 4.32348 8.66637 4.01712C8.45012 3.71077 8.01186 3.62799 7.68748 3.83222L5.64706 5.6083L3.67353 3.83222Z"
      fill="currentColor"
    />
  </svg>
  <svg
    v-if="icon == 'doubletick'"
    :class="attrs.class"
    viewBox="0 0 12 7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.791 1.19497C10.0699 0.921608 10.0699 0.478392 9.791 0.205025C9.51206 -0.0683417 9.0598 -0.0683417 8.78085 0.205025L3.57164 5.31005L1.21957 3.00503C0.940629 2.73166 0.488368 2.73166 0.209422 3.00503C-0.0695238 3.27839 -0.0695238 3.72161 0.209422 3.99497L3.06657 6.79497C3.34551 7.06834 3.79777 7.06834 4.07672 6.79497L9.791 1.19497ZM11.4598 2.37886C11.7137 2.12502 11.7137 1.71346 11.4598 1.45962C11.206 1.20578 10.7944 1.20578 10.5406 1.45962L6.45983 5.54038C6.20599 5.79422 6.20599 6.20578 6.45983 6.45962C6.71367 6.71346 7.12523 6.71346 7.37907 6.45962L11.4598 2.37886Z"
      fill="currentColor"
    />
  </svg>
  <svg
    v-if="icon == 'enter'"
    :class="attrs.class"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path
      d="M19,6a1,1,0,0,0-1,1v4a1,1,0,0,1-1,1H7.41l1.3-1.29A1,1,0,0,0,7.29,9.29l-3,3a1,1,0,0,0-.21.33,1,1,0,0,0,0,.76,1,1,0,0,0,.21.33l3,3a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42L7.41,14H17a3,3,0,0,0,3-3V7A1,1,0,0,0,19,6Z"
    />
  </svg>
  <svg v-if="icon == 'ethscan'" :class="attrs.class" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12ZM5.71751 3.09617C5.44137 3.09617 5.21751 3.32003 5.21751 3.59617C5.21751 3.87231 5.44137 4.09617 5.71752 4.09617H7.33884L3.24264 8.19237C3.04738 8.38763 3.04738 8.70421 3.24264 8.89947C3.4379 9.09474 3.75449 9.09473 3.94975 8.89947L8.04594 4.80328V6.4246C8.04594 6.70074 8.2698 6.9246 8.54594 6.9246C8.82208 6.9246 9.04594 6.70074 9.04594 6.4246V3.59617C9.04594 3.32003 8.82209 3.09617 8.54594 3.09617L5.71751 3.09617Z"
      fill="currentColor"
    />
  </svg>
  <svg
    v-if="icon == 'github'"
    :class="attrs.class"
    viewBox="0 0 12 12"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.99975 3.40537e-07C4.57463 -0.000485631 3.19588 0.519181 2.11033 1.46596C1.02479 2.41274 0.303343 3.7248 0.0751629 5.16724C-0.153017 6.60968 0.126968 8.08831 0.864991 9.33839C1.60301 10.5885 2.75088 11.5284 4.10308 11.9898C4.40114 12.0469 4.51242 11.8564 4.51242 11.6934C4.51242 11.5467 4.50745 11.0627 4.50447 10.5483C2.83532 10.9201 2.48361 9.82291 2.48361 9.82291C2.21038 9.10977 1.81694 8.92232 1.81694 8.92232C1.27248 8.54028 1.85767 8.54843 1.85767 8.54843C2.46075 8.59224 2.77769 9.1821 2.77769 9.1821C3.31321 10.1224 4.18157 9.85143 4.52335 9.69148C4.57799 9.29417 4.73298 9.02318 4.90487 8.86934C3.5765 8.71551 2.17064 8.18779 2.17064 5.83038C2.16172 5.21808 2.38343 4.62584 2.78962 4.17693C2.72702 4.02207 2.52136 3.39655 2.84724 2.54691C2.84724 2.54691 3.35097 2.38187 4.49752 3.17752C5.48129 2.90177 6.51921 2.90177 7.50298 3.17752C8.64357 2.38594 9.15127 2.54691 9.15127 2.54691C9.47715 3.39452 9.27248 4.02004 9.20988 4.17693C9.61496 4.62559 9.83592 5.217 9.82687 5.82834C9.82687 8.19187 8.42399 8.71144 7.08768 8.86425C7.30228 9.05476 7.49404 9.42966 7.49404 10.0032C7.49404 10.8264 7.48808 11.4896 7.48808 11.6913C7.48808 11.8553 7.59538 12.0469 7.8994 11.9868C9.24964 11.5236 10.3952 10.5831 11.1314 9.33349C11.8677 8.08387 12.1465 6.60652 11.9181 5.16549C11.6897 3.72445 10.969 2.41365 9.88483 1.46736C8.80061 0.521067 7.42355 0.000962363 5.99975 3.40537e-07Z"
      fill="currentColor"
    />
  </svg>
  <svg
    v-if="icon == 'reddit'"
    :class="attrs.class"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path
      d="M24 11.779c0-1.459-1.192-2.645-2.657-2.645-.715 0-1.363.286-1.84.746-1.81-1.191-4.259-1.949-6.971-2.046l1.483-4.669 4.016.941-.006.058c0 1.193.975 2.163 2.174 2.163 1.198 0 2.172-.97 2.172-2.163s-.975-2.164-2.172-2.164c-.92 0-1.704.574-2.021 1.379l-4.329-1.015c-.189-.046-.381.063-.44.249l-1.654 5.207c-2.838.034-5.409.798-7.3 2.025-.474-.438-1.103-.712-1.799-.712-1.465 0-2.656 1.187-2.656 2.646 0 .97.533 1.811 1.317 2.271-.052.282-.086.567-.086.857 0 3.911 4.808 7.093 10.719 7.093s10.72-3.182 10.72-7.093c0-.274-.029-.544-.075-.81.832-.447 1.405-1.312 1.405-2.318zm-17.224 1.816c0-.868.71-1.575 1.582-1.575.872 0 1.581.707 1.581 1.575s-.709 1.574-1.581 1.574-1.582-.706-1.582-1.574zm9.061 4.669c-.797.793-2.048 1.179-3.824 1.179l-.013-.003-.013.003c-1.777 0-3.028-.386-3.824-1.179-.145-.144-.145-.379 0-.523.145-.145.381-.145.526 0 .65.647 1.729.961 3.298.961l.013.003.013-.003c1.569 0 2.648-.315 3.298-.962.145-.145.381-.144.526 0 .145.145.145.379 0 .524zm-.189-3.095c-.872 0-1.581-.706-1.581-1.574 0-.868.709-1.575 1.581-1.575s1.581.707 1.581 1.575-.709 1.574-1.581 1.574z"
    />
  </svg>
  <svg
    v-if="icon == 'telegram'"
    :class="attrs.class"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 172 172"
    fill="currentColor"
  >
    <path
      d="M158.71128,22.53888c-2.58,-2.18784 -6.63232,-2.50088 -10.82224,-0.81872h-0.00688c-4.40664,1.76816 -124.73784,53.38192 -129.6364,55.49064c-0.89096,0.3096 -8.67224,3.21296 -7.87072,9.68016c0.71552,5.8308 6.96944,8.24568 7.73312,8.52432l30.59192,10.4748c2.0296,6.75616 9.5116,31.6824 11.16624,37.00752c1.032,3.3196 2.71416,7.68152 5.66224,8.57936c2.58688,0.9976 5.16,0.086 6.82496,-1.2212l18.70328,-17.34792l30.19288,23.5468l0.71896,0.43c2.05024,0.90816 4.01448,1.36224 5.88928,1.36224c1.44824,0 2.838,-0.27176 4.16584,-0.81528c4.5236,-1.8576 6.33304,-6.16792 6.52224,-6.6564l22.55264,-117.22488c1.376,-6.2608 -0.53664,-9.44624 -2.38736,-11.01144zM75.68,110.08l-10.32,27.52l-10.32,-34.4l79.12,-58.48z"
    ></path>
  </svg>
  <svg v-if="icon == 'layouts'" :class="attrs.class" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.66669 3.33366C2.66669 2.96547 2.96516 2.66699 3.33335 2.66699H12.6667C13.0349 2.66699 13.3334 2.96547 13.3334 3.33366V4.66699C13.3334 5.03518 13.0349 5.33366 12.6667 5.33366H3.33335C2.96516 5.33366 2.66669 5.03518 2.66669 4.66699V3.33366Z"
      stroke="#F1F5F9"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M2.66669 8.66699C2.66669 8.2988 2.96516 8.00033 3.33335 8.00033H7.33335C7.70154 8.00033 8.00002 8.2988 8.00002 8.66699V12.667C8.00002 13.0352 7.70154 13.3337 7.33335 13.3337H3.33335C2.96516 13.3337 2.66669 13.0352 2.66669 12.667V8.66699Z"
      stroke="#F1F5F9"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.6667 8.66699C10.6667 8.2988 10.9652 8.00033 11.3334 8.00033H12.6667C13.0349 8.00033 13.3334 8.2988 13.3334 8.66699V12.667C13.3334 13.0352 13.0349 13.3337 12.6667 13.3337H11.3334C10.9652 13.3337 10.6667 13.0352 10.6667 12.667V8.66699Z"
      stroke="#F1F5F9"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
  <svg
    v-if="icon == 'line-chart'"
    :class="attrs.class"
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 275.542 275.542"
    style="enable-background: new 0 0 275.542 275.542"
    xml:space="preserve"
    fill="currentColor"
  >
    <g>
      <g>
        <g>
          <path
            d="M18.516,221.078l75.268-94.719h117.112c2.723,0,5.271-1.317,6.818-3.524l36.82-52.561
				l18.477,11.525l2.531-60.113l-54.179,27.9l19.176,11.96l-33.994,48.524H89.747c-2.547,0-4.953,1.153-6.523,3.127l-66.665,83.896
				V14.552c0-4.498-3.707-8.145-8.279-8.145S0,10.054,0,14.552V260.99c0,4.498,3.707,8.145,8.279,8.145h250.475
				c4.572,0,8.279-3.646,8.279-8.145s-3.707-8.145-8.279-8.145H16.558v-30.044C17.276,222.328,17.955,221.783,18.516,221.078z"
          />
        </g>
      </g>
    </g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
  </svg>
  <svg
    v-if="icon == 'candle-chart'"
    :class="attrs.class"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.5 0V14.5H15M8.5 0V3.5M3.5 9.5V12M3.5 4V5.5M13.5 4V6.5M13.5 10.5V13M2.5 5.5H4.5V9.5H2.5V5.5ZM7.5 3.5H9.5V7.5H7.5V3.5ZM12.5 6.5H14.5V10.5H12.5V6.5Z"
      stroke="currentColor"
    />
  </svg>
  <svg
    v-if="icon == 'play-slash'"
    :class="attrs.class"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.8799 20.4482C20.1523 20.7207 20.6094 20.7207 20.873 20.4482C21.1367 20.167 21.1455 19.7275 20.873 19.4551L7.43457 6.02539C7.16211 5.75293 6.71387 5.75293 6.43262 6.02539C6.16895 6.28906 6.16895 6.75488 6.43262 7.01855L19.8799 20.4482ZM19.0186 16.0449L20.8203 14.999C21.5762 14.5596 21.8926 14.2168 21.8926 13.6631C21.8926 13.1094 21.5762 12.7754 20.8203 12.3271L10.4404 6.32422C10.0713 6.10449 9.77246 5.96387 9.44727 5.96387C9.30664 5.96387 9.18359 6.04297 9.12207 6.15723L19.0186 16.0449ZM15.7842 17.917L8.11133 10.2441V19.9473C8.11133 20.8262 8.62109 21.3711 9.3418 21.3711C9.71094 21.3711 10.0361 21.2393 10.4404 21.002L15.7842 17.917Z"
      fill="currentColor"
    />
  </svg>
  <svg v-if="icon == 'reply'" :class="attrs.class" viewBox="0 0 29 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.00979 14C2.00981 13.48 0.999512 1 13.4995 1C25.9996 1 28.9995 1 28.9995 1"
      stroke="currentColor"
      stroke-width="2"
    />
  </svg>
  <svg
    v-if="icon == 'slack'"
    :class="attrs.class"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 172 172"
  >
    <g
      fill="none"
      fill-rule="nonzero"
      stroke="none"
      stroke-width="1"
      stroke-linecap="butt"
      stroke-linejoin="miter"
      stroke-miterlimit="10"
      stroke-dasharray=""
      stroke-dashoffset="0"
      font-family="none"
      font-weight="none"
      font-size="none"
      text-anchor="none"
      style="mix-blend-mode: normal"
    >
      <path d="M0,172v-172h172v172z" fill="none"></path>
      <g fill="currentColor">
        <path
          d="M64.5,50.16667c-4.59383,0 -31.25383,0 -35.83333,0c-7.91917,0 -14.33333,6.41417 -14.33333,14.33333c0,7.91917 6.41417,14.33333 14.33333,14.33333c4.5795,0 31.2395,0 35.83333,0c7.91917,0 14.33333,-6.41417 14.33333,-14.33333c0,-7.91917 -6.41417,-14.33333 -14.33333,-14.33333zM78.83333,29.4335v9.98317c0,1.978 -1.58383,3.58333 -3.56183,3.58333c-3.45433,0 -8.49967,0 -10.7715,0c-7.91917,0 -14.33333,-6.41417 -14.33333,-14.33333c0,-8.7075 7.7615,-15.59467 16.74133,-14.13983c7.04483,1.14667 11.92533,7.76867 11.92533,14.90667zM50.16667,100.33333c0,4.59383 0,31.25383 0,35.83333c0,7.91917 6.41417,14.33333 14.33333,14.33333c7.91917,0 14.33333,-6.41417 14.33333,-14.33333c0,-4.5795 0,-31.2395 0,-35.83333c0,-7.91917 -6.41417,-14.33333 -14.33333,-14.33333c-7.91917,0 -14.33333,6.41417 -14.33333,14.33333zM29.4335,86h9.98317c1.978,0 3.58333,1.58383 3.58333,3.56183c0,3.45433 0,8.4925 0,10.7715c0,7.91917 -6.41417,14.33333 -14.33333,14.33333c-8.7075,0 -15.59467,-7.7615 -14.13983,-16.74133c1.14667,-7.052 7.7615,-11.92533 14.90667,-11.92533zM100.33333,114.66667c4.59383,0 31.25383,0 35.83333,0c7.91917,0 14.33333,-6.41417 14.33333,-14.33333c0,-7.91917 -6.41417,-14.33333 -14.33333,-14.33333c-4.5795,0 -31.2395,0 -35.83333,0c-7.91917,0 -14.33333,6.41417 -14.33333,14.33333c0,7.912 6.41417,14.33333 14.33333,14.33333zM86,135.39983v-9.98317c0,-1.978 1.58383,-3.58333 3.56183,-3.58333c3.45433,0 8.49967,0 10.7715,0c7.91917,0 14.33333,6.41417 14.33333,14.33333c0,8.7075 -7.7615,15.59467 -16.74133,14.13983c-7.052,-1.15383 -11.92533,-7.76867 -11.92533,-14.90667zM114.66667,64.5c0,-4.59383 0,-31.25383 0,-35.83333c0,-7.91917 -6.41417,-14.33333 -14.33333,-14.33333c-7.91917,0 -14.33333,6.41417 -14.33333,14.33333c0,4.5795 0,31.2395 0,35.83333c0,7.91917 6.41417,14.33333 14.33333,14.33333c7.912,0 14.33333,-6.42133 14.33333,-14.33333zM135.39983,78.83333h-9.98317c-1.978,0 -3.58333,-1.58383 -3.58333,-3.56183c0,-3.45433 0,-8.49967 0,-10.7715c0,-7.91917 6.41417,-14.33333 14.33333,-14.33333c8.7075,0 15.59467,7.7615 14.13983,16.74133c-1.15383,7.04483 -7.76867,11.92533 -14.90667,11.92533z"
        ></path>
      </g>
    </g>
  </svg>
  <svg
    v-if="icon == 'webhook'"
    :class="attrs.class"
    viewBox="-10 -5 1034 1034"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    version="1.1"
  >
    <path
      fill="currentColor"
      d="M482 226h-1l-10 2q-33 4 -64.5 18.5t-55.5 38.5q-41 37 -57 91q-9 30 -8 63t12 63q17 45 52 78l13 12l-83 135q-26 -1 -45 7q-30 13 -45 40q-7 15 -9 31t2 32q8 30 33 48q15 10 33 14.5t36 2t34.5 -12.5t27.5 -25q12 -17 14.5 -39t-5.5 -41q-1 -5 -7 -14l-3 -6l118 -192
q6 -9 8 -14l-10 -3q-9 -2 -13 -4q-23 -10 -41.5 -27.5t-28.5 -39.5q-17 -36 -9 -75q4 -23 17 -43t31 -34q37 -27 82 -27q27 -1 52.5 9.5t44.5 30.5q17 16 26.5 38.5t10.5 45.5q0 17 -6 42l70 19l8 1q14 -43 7 -86q-4 -33 -19.5 -63.5t-39.5 -53.5q-42 -42 -103 -56
q-6 -2 -18 -4l-14 -2h-37zM500 350q-17 0 -34 7t-30.5 20.5t-19.5 31.5q-8 20 -4 44q3 18 14 34t28 25q24 15 56 13q3 4 5 8l112 191q3 6 6 9q27 -26 58.5 -35.5t65 -3.5t58.5 26q32 25 43.5 61.5t0.5 73.5q-8 28 -28.5 50t-48.5 33q-31 13 -66.5 8.5t-63.5 -24.5
q-4 -3 -13 -10l-5 -6q-4 3 -11 10l-47 46q23 23 52 38.5t61 21.5l22 4h39l28 -5q64 -13 110 -60q22 -22 36.5 -50.5t19.5 -59.5q5 -36 -2 -71.5t-25 -64.5t-44 -51t-57 -35q-34 -14 -70.5 -16t-71.5 7l-17 5l-81 -137q13 -19 16 -37q5 -32 -13 -60q-16 -25 -44 -35
q-17 -6 -35 -6zM218 614q-58 13 -100 53q-47 44 -61 105l-4 24v37l2 11q2 13 4 20q7 31 24.5 59t42.5 49q50 41 115 49q38 4 76 -4.5t70 -28.5q53 -34 78 -91q7 -17 14 -45q6 -1 18 0l125 2q14 0 20 1q11 20 25 31t31.5 16t35.5 4q28 -3 50 -20q27 -21 32 -54
q2 -17 -1.5 -33t-13.5 -30q-16 -22 -41 -32q-17 -7 -35.5 -6.5t-35.5 7.5q-28 12 -43 37l-3 6q-14 0 -42 -1l-113 -1q-15 -1 -43 -1l-50 -1l3 17q8 43 -13 81q-14 27 -40 45t-57 22q-35 6 -70 -7.5t-57 -42.5q-28 -35 -27 -79q1 -37 23 -69q13 -19 32 -32t41 -19l9 -3z"
    />
  </svg>
</template>
<script setup>
import { useAttrs } from 'vue';
defineProps({ icon: String });
const attrs = useAttrs();
</script>
